export interface IEntryBarcodeKey {
  EntryNum: number
  DetailNum: number
}

const ENTRY_BARCODE_RE = /^(\d+)-(\d+)$/

/** Баркод строки входа `EntryNum-DetailNum` → ключ строки; null, если формат не тот. */
export const parseEntryBarcode = (barcode: string): IEntryBarcodeKey | null => {
  const match = barcode.trim().match(ENTRY_BARCODE_RE)
  if (!match) return null
  return { EntryNum: Number(match[1]), DetailNum: Number(match[2]) }
}
